import signalRConnection from "@/Connection/connection-hub";
import HydrogenLayout from "@/layouts/hydrogen/layout";
import routes from "@/routers/routes";
import useAuthStore from "@/store/AuthStore";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function DefaultLayout() {
    const { logOut, isAuthorized, auth } = useAuthStore((s) => s);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthorized) {
            logOut();
            navigate(routes.auth.login);
            return;
        }

        signalRConnection.on("LogOut", () => {
            // console.log("LogOut", data);
            logOut();

            navigate(routes.auth.login);
        });
    }, [isAuthorized, auth]);

    return <HydrogenLayout />;
}
